import axios from "axios";
console.log("🔥 USING AXIOS INSTANCE WITH BASE URL:", process.env.REACT_APP_BACKEND_URL);

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

export default axiosInstance;


